/* eslint-disable react-hooks/exhaustive-deps */
import {  useBoolean } from '@chakra-ui/react';
import { useContext } from 'react';
import {
  MyAccountContext,
} from '../../../providers/MyAccountProvider';
import EditAccountsModal from './EditAccountsModal';

const DepartmentMyAccount = ({ getData }) => {
  const myAccountContext = useContext(MyAccountContext);
  const currentUser = myAccountContext.currentUserType;

  const [isAccountModalOpen, setIsAccountModalOpen] = useBoolean(false);
  return (
    <>
      <EditAccountsModal
        isOpen={isAccountModalOpen}
        onClose={setIsAccountModalOpen.off}
        accountData={currentUser}
        getData={getData}
      />
    </>
  );
};

export default DepartmentMyAccount;
